import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Card,
  CardContent,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core"
import { SchemaContext } from "../contexts/SchemaContext"
import UploadFileButton from "../components/UploadFileButton"
import DownloadFileButton from "./DownloadFileButton"
import { green, red } from "@material-ui/core/colors"
import { useContext } from "react"

const useStyles = makeStyles((theme) => ({
  card: {
    "& > *": {
      margin: theme.spacing(1),
    },
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  cardContent: {
    width: 300,
  },
  error: {
    color: red[500],
  },
  input: {
    display: "none",
  },
  title: {
    fontSize: 20,
    textTransform: "uppercase",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
  },
  button: {
    minWidth: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    position: "relative",
  },
}))

const ProductAllocationCard = () => {
  const [option, setOption] = useState("")
  const classes = useStyles()
  const { schema } = useContext(SchemaContext)
  const options = schema.filter((button) => button.button_type_id === 5)

  const handleChange = (event) => {
    setOption(event.target.value)
  }

  const resetForm = () => {
    setOption("")
  }

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          Product Allocation
        </Typography>
        {options && (
          <>
            <FormControl className={classes.formControl}>
              <InputLabel id="media-select-label">Form Type</InputLabel>
              <Select
                labelId="media-select-label"
                id="media-simple-select"
                value={option}
                onChange={handleChange}
              >
                {options.map((item) => (
                  <MenuItem key={item.id} value={item.folder_name}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <UploadFileButton
              label="Upload Excel File"
              callBack={resetForm}
              context={option}
              disabled={option === ""}
            />
            <DownloadFileButton
              label="Download Excel Template"
              context={option}
              callBack={resetForm}
              disabled={option === ""}
            />
          </>
        )}
      </CardContent>
    </Card>
  )
}

export default ProductAllocationCard
